const type = 'SET_PAYMENT_SUBMITTING';

const setPaymentSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setPaymentSubmitting;
